import { render, staticRenderFns } from "./AddClassCategory.vue?vue&type=template&id=0849800b&scoped=true&"
import script from "./AddClassCategory.vue?vue&type=script&lang=js&"
export * from "./AddClassCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddClassCategory.vue?vue&type=style&index=0&id=0849800b&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849800b",
  null
  
)

export default component.exports